import { useGetUserInfo } from "lib/userInfo";
import * as React from "react";
import { useRecoilValue } from "recoil";

import Props from "./index.d";

interface GFCFieldSet_FieldSetDiv extends Props {
  children: React.ReactNode;
}

const ShowForRole: React.FC<GFCFieldSet_FieldSetDiv> = ({ children, role, getFieldValue }) => {
  const userInfo = useGetUserInfo();
  const withTG8Rev25ConformityState = getFieldValue("withTG8Rev25Conformity");
  const hasTG8Conformity = useRecoilValue(withTG8Rev25ConformityState);

  if (role === userInfo?.role || (hasTG8Conformity && userInfo?.role === "MANUFACTURER")) {
    return <>{children}</>;
  } else {
    return null;
  }
};

export default ShowForRole;
